import React from 'react';
import { getBetDescription } from '../data/utils/getBetDescription';
import { FullLengthOdd } from './Odd';

export default function ScrollingBetsContainer(props) {
    return (
        <>
            {props.bets.map(b => {
                {/* const desc = getBetDesc(b); */}
                const desc = getBetDescription(b);
                let odds = b.odds;
                {/* if (!props.isLive) {
                    odds = b.odds.filter(o => o.value != null);
                } */}
                return (
                    <div key={b.uniqueId} className="flex flex-col shrink-0 mr-6 last:mr-0">
                        <span className="sticky left-0 self-start font-medium text-xs uppercase">{desc}</span>
                        <div className="flex">
                            {odds.map(o =>
                                <FullLengthOdd key={o.uniqueId} className="ml-2 first:ml-0" data={o} />
                            )}
                        </div>
                    </div>
                );
            })}
        </>
    );
}